import { Toggle as TogglePrimitive } from "@base-ui/react/toggle"
import { cva, type VariantProps } from "class-variance-authority"
import { cn } from "@/modules/lib/utils"

const chipsVariants = cva(
  "group/toggle inline-flex items-center justify-center rounded-4xl whitespace-nowrap transition-all outline-none focus-visible:ring-[3px] disabled:pointer-events-none [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4",
  {
    variants: {
      variant: {
        emphasisLow:
          "border border-interactive-border-neutral-default bg-surface-background-default text-interactive-text-secondary-default hover:bg-interactive-background-neutral-faded focus-visible:ring-surface-border-gray-muted disabled:border-interactive-border-neutral-disabled disabled:bg-interactive-background-neutral-default disabled:text-interactive-text-secondary-disabled aria-pressed:border-none aria-pressed:bg-(--chip-bg-selected) aria-pressed:text-(--chip-text-selected) aria-pressed:hover:bg-interactive-background-neutral-faded aria-pressed:hover:text-interactive-text-secondary-default aria-pressed:disabled:bg-interactive-background-neutral-disabled aria-pressed:disabled:text-interactive-text-secondary-disabled",
        emphasisHigh:
          "border border-interactive-border-neutral-default text-interactive-text-secondary-default hover:bg-interactive-background-neutral-faded focus-visible:ring-surface-border-gray-muted disabled:border-interactive-border-neutral-disabled disabled:bg-interactive-background-neutral-default disabled:text-interactive-text-secondary-disabled aria-pressed:border-none aria-pressed:bg-linear-95 aria-pressed:from-interactive-background-primary-gradient-from aria-pressed:to-interactive-background-primary-gradient-to aria-pressed:hover:from-interactive-background-primary-gradient-hover-from aria-pressed:hover:to-interactive-background-primary-gradient-hover-to aria-pressed:focus-visible:ring-interactive-background-primary-faded aria-pressed:disabled:bg-interactive-background-primary-disabled aria-pressed:disabled:text-interactive-text-primary-disabled",
      },
      size: {
        md: "gap-2 px-5 py-2 label-medium",
        sm: "gap-1 px-3 py-1 label-small",
      },
    },
    defaultVariants: {
      variant: "emphasisLow",
      size: "md",
    },
  },
)

function Chip({
  className,
  variant = "emphasisLow",
  size = "md",
  ...props
}: TogglePrimitive.Props & VariantProps<typeof chipsVariants>) {
  return <TogglePrimitive data-slot="toggle" className={cn(chipsVariants({ variant, size, className }))} {...props} />
}

export { Chip, chipsVariants }
